import {
  Box,
  CardContent,
  CardHeader,
  Typography,
  useMediaQuery,
  // useMediaQuery,
  useTheme,
} from '@mui/material';
import * as React from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Accordion, Card, Dialog } from '../../components';
import FabControlled from '../../components/fab/fab-controlled';

type PropTypes = {
  open: boolean;
  onClose: any;
};

export default function CardWarranty(props: PropTypes) {
  const { open, onClose } = props;
  const theme: any = useTheme();

  const isLandscape = useMediaQuery('(orientation: landscape)');
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  const renderClose = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('lg')]: {
          margin: '0 0 0.7rem 0',
        },
        margin: '-0.8rem -0.8rem 0 0',
        zIndex: theme.zIndex.modal + 1,
      }}
    >
      <FabControlled Icon={CloseRoundedIcon} onClick={onClose} />
    </Box>
  );

  const renderHeader = (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography fontWeight={600} ml={1.5} variant="h5">
          Service Contract
        </Typography>
        {renderClose}
      </Box>

      <CardHeader
        subheader="we pride ourselves on excellent quality and back it up by offering additional peace of mind below"
        sx={{
          paddingTop: 3,
          '.MuiTypography-body1': {
            color: '#000',
            paddingTop: 1,
            fontSize: '15px',
            [theme.breakpoints.down('lg')]: {
              fontSize: 12,
            },
          },
          '.MuiTypography-root': {
            fontWeight: 700,
          },
          marginBottom: { xl: theme.spacing(3), xs: 0 },
        }}
      />
    </>
  );

  const renderContainer = (
    <Box mb={{ xl: 0, xs: '2rem' }}>
      <Box
        sx={{
          background: (theme) => theme.palette.primary.light,
          borderRadius: 2,
          display: 'flex',
          fontSize: '0.875rem',
          fontWeight: '700',
          m: 1,
        }}
      >
        <Accordion
          subText="Please contact our dealership to learn more about the extended warranty coverage we offer."
          title="Warranty coverage"
        />
      </Box>
      <Box
        sx={{
          background: (theme) => theme.palette.primary.light,
          borderRadius: 2,
          display: 'flex',
          fontSize: '0.875rem',
          fontWeight: '700',
          m: 1,
        }}
      >
        <Accordion
          subText="Please contact our dealership to learn more about our Guaranteed Asset Protection  plans we offer"
          title="GAP coverage"
        />
      </Box>
    </Box>
  );

  const renderContent = (
    <CardContent sx={{ paddingBottom: '0 !important' }}>
      <Typography
        align="center"
        display="block"
        gutterBottom
        sx={{ color: '#FF6B00' }}
        variant="caption"
      >
        A manufacturer warranty may apply for this vehicle. See store for
        details.
      </Typography>
    </CardContent>
  );

  const renderCard = (
    <Card
      cardContainer={renderContainer}
      cardContent={renderContent}
      cardHeader={renderHeader}
    />
  );

  return (
    <Dialog
      disableRenderClose={isMobile && isLandscape}
      handleClose={onClose}
      open={Boolean(open)}
      overflowBox={true}
      renderContent={Boolean(open) && renderCard}
    />
  );
}
